import { ITranslation } from "./types";

export const zh: ITranslation = {
  messageFallbacks: {
    homeOrderNotReadyMsg:
      '刚刚离开商店？您的订单正在处理，请稍后查看。<br/>In case of any issues, please reach out through venue support.',
    errorReachOutSupportMsg:
      'In case of any issues, please reach out through venue support.',
  },
  api: {
    E_FORCED_LOGOUT: "您已经被强制退出登录",
  },
  orderStatus: {
    draft: "草稿",
    contested: "有争议",
    paid: "已支付",
    unpaid: "未支付",
    pending: "待处理",
    reviewed: "已审核",
    paymentProcessing: "支付处理中",
    refunded: "已退款",
    unknown: "未知",
  },
  receiptsList: {
    headings: {
      date: "日期",
      time: "时间",
      status: "状态",
      total: "总计",
    },
    action: {
      view: "查看",
    },
    statusTooltip: {
      draft: "草稿 - 订单正在系统处理中",
      paid: "已支付 - 订单已处理并支付",
      paymentProcessing:
        "支付处理中 - 订单已处理，支付正在进行中",
      unpaid: "未支付 - 订单已处理但支付失败",
      pending:
        "待处理 - 订单已被客户质疑，正在等待零售商审核",
      reviewed:
        "已审核 - 订单已被客户质疑，零售商已提交修订",
    },
    loadMore: "加载更多",
    loadingMore: "加载中...",
    showing: "显示",
  },
  receiptDetailScreen: {
    headerTitle: "订单详情",
    subtotal: "Subtotal",
    taxBreakdown: {
      headers: {
        rate: "Tax %",
        netto: "Netto",
        brutto: "Brutto",
        tax: "Tax",
        total: "Total:",
      },
    },
    tax: "税",
    taxCRV: "CRV",
    total: "总量",
    processTime: "处理时长",
    date: "日期",
    paymentStatus: "支付状态",
    orderId: "订单号",
    listOfProducts: "產品",
  },
  receiptDetailComplain: {
    reportProblem: "报告错误",
    submitReview: "申请审核",
    confirmTitle: "订单已发送",
    confirmButton: "完成",
    addMissingItem: "添加缺失商品",
    addMissingItemMessage: "添加备注 (选填)",
    form: {
      email: {
        label: '我们如何联系您?',
        placeholder: '您的电子邮件，例如 me@example.com',
        errors: {
          required: '电子邮件地址是必需的。',
          isEmail: '无效的电子邮件地址。',
          inUse: '电子邮件地址已被使用。'
        }
      }
    }
  },
  receiptsScreen: {
    label: {
      contested: "审核中",
      draft: "草稿",
      empty: "空",
      paid: "已支付",
      pending: "草稿",
      refunded: "已退款",
      reviewed: "已审核",
      unknown: "未知",
      unpaid: "未支付",
      paymentProcessing: "支付处理中",
    },
    message: {
      contested: "争议消息",
      draft: "草稿消息",
      empty: "空消息",
      paid: "已支付",
      pending: "处理中消息",
      refunded: "已退款消息",
      reviewed: "已审核消息",
      unpaid: "未支付消息",
      paymentProcessing: "支付处理中消息",
    },
    minutes: "分钟",
    hours: "小时",
    days: "天",
  },
  slideModal: {
    close: "关闭",
    searchPlaceholder: "搜索关键词",
  },
  receiptsHome: {
    receiptPortal: "收据门户",
    selectPaymentType: "请选择您进入商店时使用的付款方式",
    selectPaymentTypeSubtitle: "如果您使用手机或智能手表付款，请选择 Apple Pay 或 Google Pay。",
    cardBin: "卡号前 %{cardBinDigitsCount} 位数字(BIN/IIN)",
    last4: "Last four digits of your payment method",
    last4Apple: "Last four digits of your Apple Pay Number",
    last4Google: "Last four digits of your Google Pay Number",
    instructionApple:
      "在Apple Wallet中找到您的Apple Pay卡号后四位，并在下方输入",
    openWallet: "打开钱包",
    instructionGoogle:
      "在Google Wallet中找到您的Google Pay卡号后四位，并在下方输入",
    instructionExternalId: "在您的支付应用或银行对账单中查找支付参考号",
    externalIdLabel: "支付参考号码",
    externalIdPlaceholder: "",
    expDate: "Expiration date",
    visitDate: "Date of your visit",
    submit: "Retrieve Receipt(s)",
    registerEmail: "Enter your email to subscribe to future receipts",
    registerEmailSuccess: "Email address updated successfully.",
    registerEmailFail:
      "Email address wasn't updated because there wasn't any receipts associated with provided credit card information and/or visit date.",
    unrecognizedError: "An unrecognized error occurred",
    inconclusiveCardInfo: "We can not find your receipt",
    optionalFieldPlaceholder: '可选',
    invalidCaptcha: "Invalid captcha, please try again",
    oasisApiError: "无法连接订单服务,请稍后重试。",
    orderNotFound: "订单未找到",
    vatNumberLabel: "增值税号",
    vatNumberOptional: "（可选）",
    vatNumberHelp: "如果您想在未来的发票中添加增值税号，请在此处填写。",
    vatNumberError: "请输入有效的葡萄牙增值税号（NIF）。",
  },
  receiptError: {
    notFound: {
      title: "未找到收据",
      message: "我们找不到此订单的收据。它可能已过期、已被删除，或者链接可能不正确。",
      retry: "重试",
      contactSupport: "联系支持",
      goBack: "返回",
    },
    serverError: {
      title: "出现错误",
      message: "这是我们的问题。请稍后再试。如果问题持续存在，请联系我们的支持团队。",
      retry: "重试",
      contactSupport: "联系支持",
    },
  },
  notFound: {
    title: "页面未找到",
    message: "出现了问题，或者链接可能不正确。",
    goHome: "返回主页",
    goBack: "返回",
  },
};
